// Config service with hardcoded values (no API fetch)
let config = {
    REACT_APP_API_URL: '/api',
    REACT_APP_RECAPTCHA_SITE_KEY: '6Le8uSgrAAAAL63nseF3TR4F0BR7VEAfihdm3DAv'
};

export async function loadConfig() {
    // Just return the hardcoded config
    console.log('Using hardcoded configuration (no API fetch)');
    return config;
}

export function getConfig(key, def = null) {
    return config[key] ?? def;
}

// Empty ENV object without hard-coded URLs
export const ENV = { };

// reCAPTCHA Configuration
// This is the actual key from AWS SSM parameters
export const RECAPTCHA_SITE_KEY = '6Le8uSgrAAAAL63nseF3TR4F0BR7VEAfihdm3DAv'; 